"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidCurrency = exports.supportedCurrencyFromString = exports.supportedCurrencyForCountry = exports.DbSupportedCurrencySchema = void 0;
const zod_1 = require("zod");
/**
 * note: this list is retrieved from Stripe's EU-country list for credit cards.
 * @link https://stripe.com/docs/currencies
 */
const COUNTRY_CODES_TO_CURRENCY = {
    AD: 'EUR',
    AT: 'EUR',
    BE: 'EUR',
    BG: 'EUR',
    HR: 'EUR',
    CY: 'EUR',
    CZ: 'EUR',
    DK: 'EUR',
    EE: 'EUR',
    FO: 'GBP',
    FI: 'EUR',
    FR: 'EUR',
    DE: 'EUR',
    GI: 'GBP',
    GR: 'EUR',
    GL: 'EUR',
    GG: 'GBP',
    VA: 'EUR',
    HU: 'EUR',
    IS: 'EUR',
    IE: 'EUR',
    IM: 'GBP',
    IL: 'EUR',
    IT: 'EUR',
    JE: 'GBP',
    LV: 'EUR',
    LI: 'EUR',
    LT: 'EUR',
    LU: 'EUR',
    MT: 'EUR',
    MC: 'EUR',
    NL: 'EUR',
    NO: 'EUR',
    PL: 'EUR',
    PT: 'EUR',
    RO: 'EUR',
    PM: 'EUR',
    SM: 'EUR',
    SK: 'EUR',
    SI: 'EUR',
    ES: 'EUR',
    SE: 'EUR',
    TR: 'EUR',
    GB: 'GBP',
};
const FALLBACK_CURRENCY = 'USD';
exports.DbSupportedCurrencySchema = zod_1.z.enum(['eur', 'gbp', 'usd']);
function supportedCurrencyForCountry(countryCode) {
    const currency = countryCode ? COUNTRY_CODES_TO_CURRENCY[countryCode.toUpperCase()] : undefined;
    return currency ?? FALLBACK_CURRENCY;
}
exports.supportedCurrencyForCountry = supportedCurrencyForCountry;
function supportedCurrencyFromString(stringValue) {
    const currency = stringValue.toUpperCase();
    switch (currency) {
        case 'USD':
        case 'GBP':
        case 'EUR':
            return currency;
        default:
            return null;
    }
}
exports.supportedCurrencyFromString = supportedCurrencyFromString;
function isValidCurrency(currency) {
    const parsedCurrency = exports.DbSupportedCurrencySchema.safeParse(currency);
    return parsedCurrency.success;
}
exports.isValidCurrency = isValidCurrency;
//# sourceMappingURL=shared.supported-currency.js.map